import React, {useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {Formik, Field, ErrorMessage, Form} from 'formik'
import * as Yup from 'yup'
import {toast} from 'react-toastify'
import Select from 'react-select'
import {useCreateGatewayConfigMutation} from '../../../../../services/cellcast'

const AddNewGatewayConfig = ({show, handleClose, refetch}: any) => {
  const [createGatewayConfig] = useCreateGatewayConfigMutation()

  const initialValues = {
    name: '',
    provider: '',
    url: '',
    username: '',
    password: '',
    supporatedFeatures: [],
  }

  // Provider options
  const providerOptions = [
    {value: 'telstra', label: 'Telstra'},
    {value: 'modica', label: 'Modica'},
    {value: 'sinch', label: 'Sinch'},
  ]

  // Supported features options
  const featureOptions = [
    {value: 'bulk-sms', label: 'bulk-sms'},
    {value: 'bulk-mms', label: 'bulk-mms'},
    {value: 'quick-sms', label: 'quick-sms'},
    {value: 'quick-mms', label: 'quick-mms'},
    {value: 'api', label: 'api'},
    {value: 'otp', label: 'otp'},
  ]

  const validationSchema = Yup.object({
    name: Yup.string().required('Gateway Name is required'),
    provider: Yup.string().required('Provider is required'),
    url: Yup.string().url('Invalid URL format'),
    username: Yup.string(),
    password: Yup.string(),
    supporatedFeatures: Yup.array(),
  })

  const handleSubmit = async (values: any, {setSubmitting, resetForm}: any) => {
    try {
      const result = await createGatewayConfig(values).unwrap()
      toast.success(result.message || 'Gateway config created successfully')
      refetch()
      handleClose()
      resetForm()
    } catch (error: any) {
      toast.error(error?.data?.message || 'Failed to create gateway config')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Create New Gateway Config</h2>
        </div>
        <div className='modal-body p-10 pb-15'>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({isSubmitting, values, setFieldValue}: any) => (
              <Form>
                <div className='row mb-5'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='name'>
                      Gateway Name
                    </label>
                    <Field
                      className='form-control form-control-lg form-control-solid'
                      type='text'
                      id='name'
                      name='name'
                      placeholder='Enter gateway name'
                    />
                    <ErrorMessage className='text-danger' name='name' component='div' />
                  </div>
                </div>

                <div className='row mb-5'>
                  <div className='col-12'>
                    <label className='col-form-label required fw-bold fs-6' htmlFor='provider'>
                      Provider
                    </label>
                    <Select
                      className='react-select-styled'
                      classNamePrefix='react-select'
                      options={providerOptions}
                      value={
                        providerOptions.find((option) => option.value === values.provider) || null
                      }
                      onChange={(selectedOption) =>
                        setFieldValue('provider', selectedOption ? selectedOption.value : '')
                      }
                      placeholder='Select Provider'
                    />
                    <ErrorMessage className='text-danger' name='provider' component='div' />
                  </div>
                </div>

                <div className='row mb-5'>
                  <div className='col-12'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='url'>
                      URL
                    </label>
                    <Field
                      className='form-control form-control-lg form-control-solid'
                      type='text'
                      id='url'
                      name='url'
                      placeholder='https://api.example.com'
                    />
                    <ErrorMessage className='text-danger' name='url' component='div' />
                  </div>
                </div>

                <div className='row mb-5'>
                  <div className='col-12'>
                    <label className='col-form-label fw-bold fs-6' htmlFor='supporatedFeatures'>
                      Supported Features
                    </label>
                    <div className='row'>
                      {featureOptions.map((feature) => (
                        <div key={feature.value} className='col-6 mb-3'>
                          <div className='form-check form-check-custom form-check-solid'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              id={`feature-${feature.value}`}
                              checked={values.supporatedFeatures.includes(feature.value)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldValue('supporatedFeatures', [
                                    ...values.supporatedFeatures,
                                    feature.value,
                                  ])
                                } else {
                                  setFieldValue(
                                    'supporatedFeatures',
                                    values.supporatedFeatures.filter(
                                      (f: string) => f !== feature.value
                                    )
                                  )
                                }
                              }}
                            />
                            <label
                              className='form-check-label fw-bold'
                              htmlFor={`feature-${feature.value}`}
                            >
                              {feature.label}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className='d-flex flex-center mt-5'>
                  <div id='kt_drawer_chat_close'>
                    <button
                      type='button'
                      onClick={handleClose}
                      className='btn btn-md btn-secondary me-3'
                      disabled={isSubmitting}
                    >
                      Cancel
                    </button>
                  </div>
                  <button type='submit' className='btn btn-md btn-primary' disabled={isSubmitting}>
                    Save Gateway
                    {isSubmitting && (
                      <Spinner
                        as='span'
                        animation='grow'
                        size='sm'
                        role='status'
                        className='ms-2'
                      />
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  )
}

export default AddNewGatewayConfig
